module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.409c7f79.ttf";